<template>
  <v-layout>
    <v-container>
      <v-alert
        color="error"
        icon="cloud_off"
        :value="!online"
        transition="scale-transition"
      >
        No Connection, using saved data.
      </v-alert>
      <v-alert color="info" :value="!hasCustomers && !loading" icon="info_outline">
        You have not been granted access to any customers yet
      </v-alert>
      <v-flex class="text-xs-center">
        <v-progress-circular v-if="loading" indeterminate v-bind:size="70" v-bind:width="7" color="primary"></v-progress-circular>
      </v-flex>
      <v-list dark v-ripple two-line v-for="(job, i) in jobs" v-bind:key="i" class="mb-2 pa-2">
        <v-list-tile :to="'/JobList/' + job.customer + '/' +job.number">
          <v-list-tile-content>
            <v-list-tile-title>Customer: {{job.customer}}</v-list-tile-title>
            <v-list-tile-sub-title>Number: {{job.number}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-container>
  </v-layout>
</template>

<script>

import { firedb, fireStore } from '../firebase'
import dbPromise from '../dbPromise'

export default {
  data () {
    return {
      userid: this.$store.getters.user.id,
      jobs: [],
      loading: true,
      online: true
    }
  },
  computed: {
    hasCustomers () {
      return this.jobs.length > 0
    }
  },
  created () {
    firedb.ref('/.info/connected').once('value')
    .then(snap => {
      if (snap.val() === true) {
        this.online = true
        this.getRemoteData()
      } else {
        this.online = false
        this.getLocalData()
      }
    })
  },
  methods: {
    getRemoteData () {
      fireStore.collection('Jobs').where('Allocated', '==', this.userid).get()
      .then(snap => {
        if (snap !== null) {
          snap.forEach((doc) => {
            dbPromise().then((db) => {
              let tx = db.transaction('jobStore', 'readwrite')
              let jobStore = tx.objectStore('jobStore')

              jobStore.put(doc.data(), doc.id)
              return tx.complete
            }).then(() => {
              this.jobs.push(doc.data())
            })
          })
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    getLocalData () {
      dbPromise().then((db) => {
        let tx = db.transaction('jobStore')
        let jobStore = tx.objectStore('jobStore')
        return (jobStore.getAll())
      }).then((val) => {
        if (val.length > 0) {
          for (let job in val) {
            this.jobs.push(val[job])
          }
        }
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CustomerList.vue?66042e6d